// extracted by mini-css-extract-plugin
module.exports = {"dialogTitle":"ChangePasswordModal_dialogTitle__WUeyR","error":"ChangePasswordModal_error__8MkGo"};